skrilla.directive('betEventAudits', function ($window) {
    return {
        templateUrl: 'directives/betEventAudits/betEventAudits.html',
        scope: {
            bet: "="
        },
        controller: function ($scope, searchService, modalService, cacheService) {
           $scope.search = function(){
               searchService.get(`bets/${$scope.bet.id}/eventAudits`).then((response) => {
                   // $scope.events = response.data;
                   $scope.tableData.data = response.data;
                   $scope.tableData.data.forEach((data) => {
                       data.hasSelections = data.selections.length > 0;
                       if(data.eventType === "BET_CREATED" || data.eventType === "BET_CREATED_WITH_REJECTION"){
                           data.oldStatus = "";
                       }
                   })
               })
           }

           let revenue = {title: "Revenue (System)", field: "revenue", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}};
           if($scope.bet.stakeSource === "PROMOTION_USER"){
               revenue.title = "Promotion (System)"
               revenue.field = "promotionSystem"
           }
           let columns =  [
                {title:"Event", field: "eventType"},
                {title: "Available (User)", field: "available", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Promotion (User)", field: "promotionUser", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Holding (User)", field: "holding", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                revenue,
                {title: "Winnings (System)", field: "winnings", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Old Status", field: "oldStatus"},
                {title: "New Status", field: "newStatus"},
                {title: "Has Selections Audit", field: "hasSelections"},
                {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}},
            ]
            if($scope.bet.stakeSource === "PROMOTION_USER"){
                columns = columns.filter(row => row.field !== "winnings")
            }
            else{
                columns = columns.filter(row => row.field !== "promotionUser")
            }

            $scope.tableData = {
                columns,
                rows: {onClick: clickRow, style: "cursor: pointer;"},
                isSkrillaTable: true,
                data: $scope.bets
            }

           function clickRow(event){
               cacheService.registerObject("betEventAudit", event)
               cacheService.registerObject("bet", $scope.bet)
               modalService.openModal("views/betEventAuditDetails/betEventAuditDetails.html", true, 'lg', true, true);
           }

        }
    };
});
